<template>
  <main class="grid-container overflow-visible">
    <Head title="Empresas participantes" />
    <!-- Home Search Section -->
    <section class="grid-container col-span-full px-0 justify-center items-center py-4 surface1">
      <div class="flex flex-col gap-1 p-2">
        <h1
          class="text-brand-bright-green font-extrabold text-center display-sm md:leading-[44px] md:tracking-tighter"
        >
          ¡Empresas participantes!
        </h1>
      </div>
    </section>
    <!-- / End Home Search Section -->
    <!-- Search results section -->
    <section class="py-2 my-[30px]">
      <div
        v-if="companies.length > 0"
        class="flex flex-col gap-4 select-none sm:flex-row sm:flex-wrap sm:gap-x-0"
      >
        <Link
          v-for="(company, key) in companies"
          :key="key"
          :href="$route('company.stand', company.id)"
          class="sm:w-1/3 px-2"
        >
          <CompanyCard :company="company" class="min-w-[250px] min-h-[275px] sm:w-full" />
        </Link>
      </div>
    </section>
    <!-- / End Search results section -->
  </main>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'

export default {
  name: 'Companies',
  layout: Layout,
  components: {
    Link,
    Head,
    CompanyCard: () => import('@/Components/CompanyCard'),
  },
  props: {
    companies: {
      type: Array,
      required: false,
      default: [],
    },
  },
}
</script>
